var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized } from '@lit/localize';
import { CommonStates } from '../../localization/helpers.js';
let LoadingDiv = class LoadingDiv extends LitElement {
    constructor() {
        super(...arguments);
        this.message = CommonStates.loading();
    }
    render() {
        return html `
      <div class="spinner"></div>
      <div class="message">${this.message}</div>
    `;
    }
};
LoadingDiv.styles = css `
    :host {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      width: 100%;
      height: 100%;
      font-size: 1.2em;
      color: #000;
    }

    .spinner {
      border: 4px solid rgba(0, 0, 0, 0.1);
      border-left-color: #007bff;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      animation: spin 1s linear infinite;
    }

    .message {
      font-size: 1rem;
      text-align: center;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  `;
__decorate([
    property({ type: String })
], LoadingDiv.prototype, "message", void 0);
LoadingDiv = __decorate([
    localized(),
    customElement("loading-div")
], LoadingDiv);
export { LoadingDiv };
//# sourceMappingURL=LoadingDiv.js.map